<template>
  <section class="yield-panel risk-panel">
    <div class="yield-title">风险预警</div>
    <div class="risk-content">
      <div class="risk-ring">
        <img src="../../assets/img/fx.png" alt="" />
      </div>
      <div class="risk-text">
        <b>综合风险偏低</b>
        <p>土壤墒情适宜，短期干旱风险低</p>
        <p>病虫害风险低，玉米高温胁迫需关注</p>
      </div>
    </div>
  </section>
</template>

<style lang="less" scoped>
@import "./YieldLeftShared.less";

.risk-panel {
  padding: 18px 28px;
}

.risk-content {
  height: calc(100% - 46px);
  padding: 40px 50px 20px 150px;
  position: relative;
}

.risk-ring {
  position: absolute;
  width: 300px;
  height: 300px;
  top: -30px;
  left: -100px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 100%;
    height: 100%;
  }
}


.risk-text {
  color: #ffffff;
  text-align: left;
}

.risk-text b {
  display: block;
  font-size: 36px;
  margin-bottom: 10px;
}

.risk-text p {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  line-height: 40px;
}
</style>
